/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Devices_EmptyInputs */

const es_user_profile_devices_empty = /** @type {(inputs: User_Profile_Devices_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay dispositivos activos`)
};

const en_user_profile_devices_empty = /** @type {(inputs: User_Profile_Devices_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No active devices`)
};

/**
* | output |
* | --- |
* | "No active devices" |
*
* @param {User_Profile_Devices_EmptyInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_devices_empty = /** @type {((inputs?: User_Profile_Devices_EmptyInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Devices_EmptyInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_devices_empty(inputs)
	return en_user_profile_devices_empty(inputs)
});
export { user_profile_devices_empty as "user.profile.devices.empty" }